export default "__VITE_ASSET__DLRZMdvL__"